export enum AppType {
  Api = 'API',
  RapidApi = 'RAPIDAPI',
  Zapier = 'ZAPIER',
  Slack = 'SLACK',
}
